import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
const Tab1 = ({
  ModeofPayment,
  DueDateBasedOn,
  PaymentTermName,
  CreditDays,
  InvoicePortion,
  DiscountType,
  Discount,
  DiscountValidityBasedOn,
  DiscountValidity,
  Description,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-2" style={{ width: "290px",
             }}>
          <div className="mb-3">
            <Input
              id="PaymentTermName"
              label="Payment Term Name"
              style={{
                height: "30px",
                border: PaymentTermName.Error ? "1px solid red" : "",
              }}
              value={PaymentTermName.PaymentTermName}
              onChange={(e) =>
                PaymentTermName.setPaymentTermName(e.target.value)
              }
            />
           
          </div>
        </div>
        <div className="col-2" style={{ width: "290px",
                }}>
          <div className="mb-3">
            <Input
              id="InvoicePortion"
              label="Invoice Portion (%)"
              style={{
                height: "30px",
                border: InvoicePortion.Error ? "1px solid red" : "",
              }}
              value={InvoicePortion.InvoicePortion}
              onChange={(e) => InvoicePortion.setInvoicePortion(e.target.value)}
            />
          </div>
        </div>
        <div className="col-2" style={{ width: "290px",
                }}>
          <div className={ModeofPayment.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={ModeofPayment.ModeofPayment_list}
              label="Mode of Payment"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={ModeofPayment.select_ModeofPayment}
              onChange={(val) => ModeofPayment.setselect_ModeofPayment(val)}
            />
          </div>
        </div>
        <div className="col-2" style={{ width: "290px",
                 }}>
          <div className={DueDateBasedOn.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={[
                { name: "Day(s) after invoice date" },
                { name: "Day(s) after the end of the invoice month" },
                { name: "Month(s) after the end of the invoice month" },
              ]}
              label="Due Date Based On"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={DueDateBasedOn.DueDateBasedOn}
              onChange={(val) => DueDateBasedOn.setDueDateBasedOn(val)}
            />
          </div>
        </div>
        <div className="col-2" style={{ width: "290px",
                 }}>
          <div className="mb-3">
            <Input
              id="CreditDays"
              label="Credit Days"
              style={{
                height: "30px",
                // border: CreditDays.Error ? "1px solid red" : "",
              }}
              value={CreditDays.CreditDays}
              onChange={(e) => CreditDays.setCreditDays(e.target.value)}
              
            />
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Discount Settings </p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={[{ name: "Percentage" }, { name: "Amount" }]}
              style={{
                height: "30px",
                border: DiscountType.Error ? "1px solid red" : "",
              }}
              label="Discount Type"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={DiscountType.DiscountType}
              onChange={(val) => DiscountType.setDiscountType(val)}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="Discount"
              label="Discount"
              style={{
                height: "30px",
                // border: Discount.Error ? "1px solid red" : "",
              }}
              value={Discount.Discount}
              onChange={(e) => Discount.setDiscount(e.target.value)}
            />
          </div>
        </div>
{Discount.Discount?.trim() !== "" && (
  <>
  <div className="col-4" >
          <div className={DiscountValidityBasedOn.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={[
                { name: "Day(s) after invoice date" },
                { name: "Day(s) after the end of the invoice month" },
                { name: "Month(s) after the end of the invoice month" },
              ]}
              label="Discount Validity Based On"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={DiscountValidityBasedOn.DiscountValidityBasedOn}
              onChange={(val) => DiscountValidityBasedOn.setDiscountValidityBasedOn(val)}
            />
          </div>
        </div>
        

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="DiscountValidity"
              label="Discount Validity"
              style={{
                height: "30px",
                // border: Discount.Error ? "1px solid red" : "",
              }}
              value={DiscountValidity.DiscountValidity}
              onChange={(e) => DiscountValidity.setDiscountValidity(e.target.value)}
            />
          </div>
        </div>

  </>
)}
        <div className="col-4">
          <div className="mb-3">
            <Textarea
              id="Description"
              label="Description"
              style={{
                height: "30px",
                border: Description.Error ? "1px solid red" : "",
              }}
              value={Description.Description}
              onChange={(e) => Description.setDescription(e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;
